import { API, graphqlOperation } from 'aws-amplify';
import { getQueryInput } from 'src/Ateam-BI/Templates/Utils/AppActivityUtils';
import { configureGenericAppSync, configurePlusAppsync } from 'src/context/AuthContextUtility';
import { RippleKeys } from 'src/generic-components/Ripple/Constants';

const cleanForMutation = (data) => {
  let cleanedParams = []
  for (let i = 0; i < data.length; i++) {
    let param = data[i]
    if (param?.hasOwnProperty('limit')) {
      delete param['limit']
    }
    if (param?.hasOwnProperty('typed_value')) {
      delete param['typed_value']
    }
    if (param?.hasOwnProperty('show_verify_loader')) {
      delete param['show_verify_loader']
    }
    if (param?.hasOwnProperty('show_verification_message')) {
      delete param['show_verification_message']
    } if (param?.hasOwnProperty('preferences')) {
      delete param['preferences']
    }
    cleanedParams.push(param)
  }
  data = cleanedParams

  return data
}


export const checkGlueJobExist = (job_name, critical, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    checkGlueJobExist(job_name: "${job_name}", critical: ${critical}) {
      status
    }
  }`
  executeQuery(qry, onSuccess, onFailure)
}

export const getGlueJobRunHistory = async (jobName, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  getGlueJobRunHistory(job_name: "${jobName}") 
}   
`;

  executeQuery(mQry, onSuccess, onFailure)
}

export const getGlueJobRunStatus = async (jobName, jobRunId, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  getGlueJobRunStatus(job_name: "${jobName}", job_run_id: "${jobRunId}") {
    allocated_capacity
    arguments
    attempt
    completed_on
    execution_time
    job_name
    log_group_name
    job_run_id
    max_capacity
    number_of_workers
    previous_run_id
    started_on
    security_configuration
    status
    worker_type
  }
}  
`;

  executeQuery(mQry, onSuccess, onFailure)
}

export const createRipple = async (data, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  createRipple(
    input: {${getQueryInput(data, [RippleKeys.last_updated_time_stamp, RippleKeys.created_time_stamp, RippleKeys.temp_ripple_id])}}
  ) {
    ripple_mapping_id
    ripple_id
    mapping_id
    app_id
    id_type
    created_time_stamp
    last_updated_time_stamp
    created_by
    last_updated_by
    approval_required
    is_dynamic_approvers_allowed
  }
} 
`;

  executeQuery(mQry, onSuccess, onFailure)
}

export const updateRipple = async (data, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  updateRipple(
    input: {${getQueryInput(data, [RippleKeys.last_updated_time_stamp, RippleKeys.created_time_stamp, RippleKeys.temp_ripple_id, RippleKeys.created_by])}}
  ) {
    ripple_mapping_id
    ripple_id
    mapping_id
    app_id
    id_type
    created_time_stamp
    last_updated_time_stamp
    created_by
    last_updated_by
    approval_required
    is_dynamic_approvers_allowed
  }
} 
`;

  executeQuery(mQry, onSuccess, onFailure)
}

export const deleteRipple = async (ripple_id, ripple_mapping_id, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  deleteRipple(input: {ripple_id: "${ripple_id}", ripple_mapping_id: "${ripple_mapping_id}"})
}
`;

  executeQuery(mQry, onSuccess, onFailure)
}

export const tancSync = async (sessionId, sync_type, trigger_source, sync_comment, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  tancSync(session_id: "${sessionId}",sync_type:"${sync_type}",trigger_source:"${trigger_source}",sync_comment:"${sync_comment}")
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}


export const tancSave = async (sessionId, comment, temp_key, save_type, trigger_source, delta_key, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  tancSave(save_comment: "${comment}", session_id: "${sessionId}", temp_key: "${temp_key}", save_type: "${save_type}", trigger_source: "${trigger_source}", delta_key: "${delta_key}")
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}


export const enableTANC = async (association_id, association_id_type, upstream, upstream_type, temp_id, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  enableTANC(
    input: {association_id: "${association_id}", association_id_type: "${association_id_type}", upstream: "${upstream}", upstream_type:"${upstream_type}" ${temp_id ? `, temp_id: "${temp_id}"` : ''}}
  )
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const enableTANCSync =  async (association_id, association_id_type, upstream, upstream_type, temp_id) => {
  var mQry = `
mutation MyMutation {
  enableTANC(
    input: {association_id: "${association_id}", association_id_type: "${association_id_type}", upstream: "${upstream}", upstream_type:"${upstream_type}" ${temp_id ? `, temp_id: "${temp_id}"` : ''}}
  )
}
`;
  // console.log(mQry)
  let result = await executeQuerySync(mQry)
  return result
}

export const reloadTANCConfigurationForFRISCO = async (tanc_id, association_id, association_id_type, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  reloadTANCConfigurationForFRISCO(
    input: {tanc_id:"${tanc_id}, association_id: "${association_id}", association_id_type: "${association_id_type}"}
  )
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const listPreference = async (association_id, association_id_type, preference_type, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  listPreference(
    association_id: "${association_id}"
    association_id_type: "${association_id_type}"
${preference_type ? `preference_type: "${preference_type}"` : ''}
  ) {
    items {
      associationId
      associationIdAndIdType
      associationIdType
      createdBy
      createdTimestamp
      information
      label
      lastUpdatedBy
      lastUpdatedTimestamp
      preferenceId
      preferenceType
      extras
    }
  }
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const listPreferenceByPreferenceType = async (preference_type, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  listPreferenceByPreferenceType(
    preference_type: "${preference_type}"
  ) {
    items {
      associationId
      associationIdAndIdType
      associationIdType
      createdBy
      createdTimestamp
      information
      label
      lastUpdatedBy
      lastUpdatedTimestamp
      preferenceId
      preferenceType
      extras
    }
  }
}
`;
  executeQuery(mQry, onSuccess, onFailure)
}


export const getPreference = async (preference_id, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  getPreference(preference_id: "${preference_id}") {
    preferenceId
    associationId
    associationIdAndIdType
    associationIdType
    createdBy
    createdTimestamp
    information
    label
    lastUpdatedBy
    lastUpdatedTimestamp
    preferenceType
  }
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}


export const updatePreference = async (preference_id, label, last_updated_by, information, onSuccess, onFailure) => {
  if(information && Array.isArray(information)){
    information = cleanForMutation(information)
  }else{
    information = cleanForMutation([information])?.[0]
  }
  var mQry = `
mutation MyMutation($input: UpdatePreferenceInput!) {
  updatePreference(
    input: $input
  ) {
    preferenceId
  }
}
`;
  let variables = {
    input: {
      preferenceId: preference_id,
      lastUpdatedBy: last_updated_by,
      information: JSON.stringify(information),
      label: label,
      lastUpdatedTimestamp: Date.now().toString()
    }
  }
  executeQuery(mQry, onSuccess, onFailure, variables)
}

export const updatePreferenceWithExtras = async (preference_id, label, last_updated_by, information, extras, onSuccess, onFailure) => {
  if(information && Array.isArray(information)){
    information = cleanForMutation(information)
  }else{
    information = cleanForMutation([information])?.[0]
  }
  
  var mQry = `
mutation MyMutation($input: UpdatePreferenceInput!) {
  updatePreference(
    input: $input
  ) {
    preferenceId
  }
}
`;
  let variables = {
    input: {
      preferenceId: preference_id,
      lastUpdatedBy: last_updated_by,
      information: JSON.stringify(information),
      label: label,
      extras: JSON.stringify(extras),
      lastUpdatedTimestamp: Date.now().toString()
    }
  }
  executeQuery(mQry, onSuccess, onFailure, variables)
}

export const createPreference = async (preference_id, preference_type, label, association_id, association_id_type, created_by, information, ttl, onSuccess, onFailure) => {
  if(information && Array.isArray(information)){
    information = cleanForMutation(information)
  }else{
    information = cleanForMutation([information])?.[0]
  }
  let epoch = Date.now().toString()
  var mQry = `
mutation MyMutation($input: CreatePreferenceInput!) {
  createPreference(
    input:  $input
  ) {
    preferenceId
  }
}
`;
  let variables = {
    input: {
      preferenceId: preference_id,
      associationIdAndIdType: `${association_id}#${association_id_type}`,
      associationId: association_id,
      associationIdType: association_id_type,
      preferenceType: preference_type,
      createdBy: created_by,
      createdTimestamp: epoch,
      label: label,
      lastUpdatedBy: created_by,
      lastUpdatedTimestamp: epoch,
      information: JSON.stringify(information)
    }
  }
  if(ttl){
    variables['input']['ttl'] = ttl
  }
  executeQuery(mQry, onSuccess, onFailure, variables)
}

export const createPreferenceWithExtras = async (preference_id, preference_type, label, association_id, association_id_type, created_by, information, extras, ttl, onSuccess, onFailure) => {
  if(information && Array.isArray(information)){
    information = cleanForMutation(information)
  }else{
    information = cleanForMutation([information])?.[0]
  }
  let epoch = Date.now().toString()
  var mQry = `
mutation MyMutation($input: CreatePreferenceInput!) {
  createPreference(
    input:  $input
  ) {
    preferenceId
  }
}
`;
  let variables = {
    input: {
      preferenceId: preference_id,
      associationIdAndIdType: `${association_id}#${association_id_type}`,
      associationId: association_id,
      associationIdType: association_id_type,
      preferenceType: preference_type,
      createdBy: created_by,
      createdTimestamp: epoch,
      label: label,
      lastUpdatedBy: created_by,
      lastUpdatedTimestamp: epoch,
      information: JSON.stringify(information),
      extras: JSON.stringify(extras)
    }
  }
  if(ttl){
    variables['input']['ttl'] = ttl
  }
  executeQuery(mQry, onSuccess, onFailure, variables)
}

export const deletePreference = async (preference_id, information, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation($input: DeletePreferenceInput!) {
  deletePreference(
    input:  $input
  ) {
    preferenceId
  }
}
`;
  let variables = {
    input: {
      preferenceId: preference_id
    }
  }
  executeQuery(mQry, onSuccess, onFailure, variables)
}

export const disableTANC = async (tanc_id, association_id, association_id_type, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  disableTANC(
    input: {tanc_id: "${tanc_id}", association_id: "${association_id}", association_id_type: "${association_id_type}"}
  )
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const disableTANCSync = async (tanc_id, association_id, association_id_type) => {
  var mQry = `
mutation MyMutation {
  disableTANC(
    input: {tanc_id: "${tanc_id}", association_id: "${association_id}", association_id_type: "${association_id_type}"}
  )
}
`;
  // console.log(mQry)
  return executeQuerySync(mQry)
}

export const tancAssociationStatus = (association_id, association_id_type, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  tancAssociationStatus(association_id: "${association_id}", association_id_type: "${association_id_type}") {
    account
    association_id
    association_id_type
    configurations {
      key
      service_id
      service_type
      value
    }
    tanc_id
    type
    upstream
    upstream_type
    status
  }
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const tancAssociationStatusSync = async (processId, tancKey) => {
    return new Promise((resolve, reject) => {
      tancAssociationStatus(processId, tancKey, (response) => {
        resolve(response?.data?.tancAssociationStatus?.tanc_id)
      }, (error) => reject(error))
    })
  }

export const updateTANCLock = async (session_id, isLocked, lockedBy, lockMessage, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  updateTANCLock(
    input: {sessionId: "${session_id}", isLocked: ${isLocked}, lockedBy: "${lockedBy}", lockMessage: "${lockMessage}"}
  ) {
    isLocked
    sessionId
    lockedBy
    lockMessage
    lockLastUpdatedTimestamp
  }
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const getAssociatedTANCSession = async (association_id, association_id_type, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
  getAssociatedTANCSession(association_id: "${association_id}", association_id_type: "${association_id_type}") {
    items {
      createdBy
      createdTimestamp
      isLocked
      lastUpdatedBy
      s3Uri
      sessionId
      status
      syncStatus
      tancId
      version
      lockedBy
      lockMessage
      lockLastUpdatedTimestamp
    }
    nextToken
  }
}`
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const getTANCSession = async (session_id, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
  getTANCSession(sessionId: "${session_id}") {
    createdBy
    createdTimestamp
    isLocked
    lastUpdatedBy
    lockLastUpdatedTimestamp
    lockMessage
    lockedBy
    s3Uri
    sessionId
    status
    syncStatus
    tancId
    version
  }
}`
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const getTANCSessionSync = async (session_id) => {
  var mQry = `query MyQuery {
  getTANCSession(sessionId: "${session_id}") {
    createdBy
    createdTimestamp
    isLocked
    lastUpdatedBy
    lockLastUpdatedTimestamp
    lockMessage
    lockedBy
    s3Uri
    sessionId
    status
    syncStatus
    tancId
    version
  }
}`
  // console.log(mQry)
  try {
    const result = await executeQuerySync(mQry);
    return result.data.getTANCSession;
  } catch (error) {
    // console.error('Error fetching TANC session:', error);
  }
}

export const getTancDetails = async (tanc_id, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
  getTancDetails(tanc_id: "${tanc_id}") {
    tanc_id
    association_id
    association_id_type
    type
    upstream
    upstream_type
    account
    status
  }
}`
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const getTancDetailsSync = async (tanc_id) => {
  var mQry = `query MyQuery {
  getTancDetails(tanc_id: "${tanc_id}") {
    tanc_id
    association_id
    association_id_type
    type
    upstream
    upstream_type
    account
    status
  }
}`
  // console.log(mQry)
  try {
    const result = await executeQuerySync(mQry);
    return result.data.getTancDetails;
  } catch (error) {
    // console.error('Error fetching TANC session:', error);
  }
}

export const getAssociatedTANCSessionSync = async (association_id, association_id_type) => {
  var mQry = `query MyQuery {
  getAssociatedTANCSession(association_id: "${association_id}", association_id_type: "${association_id_type}") {
    items {
      createdBy
      createdTimestamp
      isLocked
      lastUpdatedBy
      s3Uri
      sessionId
      status
      syncStatus
      tancId
      version
      lockedBy
      lockMessage
      lockLastUpdatedTimestamp
    }
    nextToken
  }
}`
  // console.log(mQry)
  try {
    const result = await executeQuerySync(mQry);
    return result.data.getAssociatedTANCSession;
  } catch (error) {
    console.error('Error fetching TANC session:', error);
  }
}

export const getBrassAllLDAPS = async (stage, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
  getBrassAllLDAPS(stage: "${stage}")
}`
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const getAllRipples = async (mapping_id, id_type, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  getAllRipples(id_type: "${id_type}", mapping_id: "${mapping_id}") {
    approval_required
    created_by
    created_time_stamp
    id_type
    last_updated_by
    mapping_id
    last_updated_time_stamp
    is_dynamic_approvers_allowed
    resend_old_parameters
    ripple_mapping_id
    ripple_id
    task
    parameters {
      field_id
      field_type
      field_values
      info
      label
    }
    approvers {
      alias
      column_index
      type
    }
  }
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}

export const getAllRipplesSync = (mappingId, idType) => {
  return new Promise((resolve, reject) => {
    getAllRipples(mappingId, idType, (response) => {
      resolve(response);
    }, (error) => reject(error))
  })
}


export const onNotifyUpdate = (sessionId, onResult, onFailure) => {
  configurePlusAppsync()
  let qry = `subscription MySubscription {
    onNotifyUpdate(sessionId: "${sessionId}") {
      sessionId
      payload
    }
  }   
  `
  executeSubscription(qry, onResult, onFailure)
}

export const tancUpdateSubscribers = async (sessionId, payload, onSuccess, onFailure) => {
  var mQry = `mutation MyMutation($sessionId: String!, $payload: AWSJSON!) {
                  tancUpdateSubscribers(input: $payload , sessionId: $sessionId) {
                  sessionId
                  payload
                  }
              }`
  let variables = {
    sessionId: sessionId,
    payload: JSON.stringify(payload)
  }
  // console.log(mQry, variables)
  executeQuery(mQry, onSuccess, onFailure, variables=variables)
}

export const listTANCVersions = async(sessionId, onSuccess, onFailure) => {
  let nextToken = null
  function getQry(sessionId, nextToken) {
    var mQry = `query MyQuery {
  listTANCVersions(
    filter: {sessionId: {eq: "${sessionId}"}}
    ${nextToken ? `nextToken: "${nextToken}"` : ''}
    limit: 1000
  ) {
    items {
      createdTimestamp
      lastUpdatedTimestamp
      previousVersion
      s3Path
      sessionId
      syncType
      triggerComments
      triggerSource
      triggerType
      triggeredBy
      version
      delta {
        bucket
        fileUris
      }
    }
    nextToken
  }
}`

    return mQry
  }
  // console.log(mQry)
  try{
    let versions = new Set()
    let result = await executeQuerySync(getQry(sessionId, nextToken), onSuccess, onFailure)
    versions = new Set([...versions,...result.data.listTANCVersions.items])
    nextToken = result?.data?.listTANCVersions?.nextToken
    while(nextToken != null){
      let nextResult = await executeQuerySync(getQry(sessionId, nextToken), onSuccess, onFailure, nextToken)
      versions = new Set([...versions,...nextResult.data.listTANCVersions.items])
      nextToken = nextResult?.data?.listTANCVersions?.nextToken
    }
    if(onSuccess){
      // message to keep it uniform as other API appsycn responses
      onSuccess({'data':{'listTANCVersions':versions}})
    }
  }catch(error){
    if(onFailure){
      onFailure(error)
    }
  }
  
}

export const getPresignedUrlForVersionFile = async (sessionId, version, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
  getPresignedUrlForVersionFile(
    sessionId: "${sessionId}"
    version: "${version}"
  )
}`

  executeQuery(mQry, onSuccess, onFailure)
}

export const getAppMetadataFieldValuesV2RDS = async () => {
  let mQry = `
    query MyQuery {
        getAppMetadataFieldValuesV2RDS(types: []) {
          type
          visibility
          values {
            label
            value
            value_id
          }
        }
      }  
        `;

  return executeQuerySync(mQry);
}

export const listServicesWithTracksForQuarter = async (app_id,aliasId = "", quarter, isAdmin = false, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
    listServicesWithTracksForQuarter(app_id: "${app_id}", quarter: "${quarter}" ${aliasId ? `, alias: "${aliasId}"` : ''}, isAdmin: ${isAdmin})
  }`

  executeQuery(mQry, onSuccess, onFailure)
}

export const corpReportingCanViewAliases = async (stage, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
    getCorpReportingAliases(stage: "${stage}")
  }`

  executeQuery(mQry, onSuccess, onFailure)
}

export const executeSubscription = async (qry, onResult, onFailure, variables = null, maxRetries = 3, delay = 1000) => {
  let retryCount = 0;

  const attemptSubscription = async () => {
    try {
      await configurePlusAppsync();
      
      const subs = API.graphql(
        variables ? graphqlOperation(qry, variables) : graphqlOperation(qry)
      ).subscribe({
        next: (response) => {
          onResult(response);
        },
        error: async (error) => {        
          if (retryCount < maxRetries) {
            retryCount++;
            // console.log(`Retry attempt ${retryCount} of ${maxRetries}`);
            
            // Exponential backoff
            const backoffDelay = delay * Math.pow(2, retryCount - 1);
            
            setTimeout(async () => {
              await attemptSubscription();
            }, backoffDelay);
          } else {
            // console.log('Max retries reached, calling onFailure');
            onFailure(error);
            await configureGenericAppSync();
          }
        },
      });

      return subs;
    } catch (error) {
      console.error('Error in subscription setup:', error);
      onFailure(error);
      await configureGenericAppSync();
      return null;
    }
  };

  return attemptSubscription();
};


export const setAppDeliverablesLockStatus = (app_id, is_locked, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  setAppDeliverablesLockStatus(app_id: "${app_id}", is_locked: ${is_locked}) {
    app_id
    is_locked
  }
}
`;
  executeQuery(mQry, onSuccess, onFailure)
}

export const getAppDeliverablesLockStatus = (app_id, onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  getAppDeliverablesLockStatus(app_id: "${app_id}") {
    app_id
    is_locked
  }
}
`;
  executeQuery(mQry, onSuccess, onFailure)
}

export const getNonAmazonAliases = (onSuccess, onFailure) => {
  var mQry = `
query MyQuery {
  getNonAmazonAliases
}
`;
  executeQuery(mQry, onSuccess, onFailure)
}

export const addNonAmazonAlias = (alias, email, created_by, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation($input: AddNonAmazonAliasInput!) {
  addNonAmazonAlias(input: $input)
}
`;
  let variables = {
    input: {
      alias: alias,
      email: email,
      created_by: created_by
    }
  }
  executeQuery(mQry, onSuccess, onFailure, variables)
}

export const deleteNonAmazonAlias = (alias, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation($input: DeleteNonAmazonAliasInput!) {
  deleteNonAmazonAlias(input: $input)
}
`;
  let variables = {
    input: {
      alias: alias
    }
  }
  executeQuery(mQry, onSuccess, onFailure, variables)
}

export const downloadFolderAsZip = (folder_id, onSuccess, onFailure) => {
  const mQry = `mutation MyMutation {
    triggerWorkdocsZip(folder_id: "${folder_id}")
  }`
  executeQuery(mQry, onSuccess, onFailure)
}

export const getWorkdocsQuarterFolderId = (parent_folder_id, onSuccess, onFailure) => {
  const mQry = `query MyQuery {
    getWorkdocsQuarterFolderId(parent_folder_id: "${parent_folder_id}")
  }`
  executeQuery(mQry, onSuccess, onFailure)
}

export const addGRCControls = async (triggerQuarter, triggerYear, onSuccess, onFailure) => {
  var mQry = `
mutation MyMutation {
  addGRCControls(trigger_quarter: "${triggerQuarter}", trigger_year: ${triggerYear})
}
`;
  // console.log(mQry)
  executeQuery(mQry, onSuccess, onFailure)
}


export const executeQuery = async (mQry, onSuccess, onFailure, variables = null, maxRetries = 3, retryDelay = 1000) => {
  let attempts = 0;

  const executeWithRetry = async () => {
    try {
      attempts++;
      await configurePlusAppsync();

      let result = null
      if (variables == null) {
        result = await API.graphql(graphqlOperation(mQry));
      } else {
        result = await API.graphql(graphqlOperation(mQry, variables));
      }
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      // If we haven't reached max retries, try again
      if (attempts < maxRetries) {
        const delay = retryDelay * Math.pow(2, attempts - 1); // Exponential backoff

        await new Promise(resolve => setTimeout(resolve, delay));
        return executeWithRetry(); // Recursive retry
      }

      // If we've exhausted all retries, call onFailure
      await configureGenericAppSync();
      if (onFailure) {
        onFailure(error);
      }
    }
  };

  try {
    await configurePlusAppsync()
    await executeWithRetry();
  } finally {
    await configureGenericAppSync();
  }
};


export const executeQuerySync = async (mQry, variables = null, maxRetries = 3, retryDelay = 1000) => {
  let attempts = 0;

  const executeWithRetry = async () => {
    try {
      attempts++;
      await configurePlusAppsync();

      let result = null;
      if (variables == null) {
        result = await API.graphql(graphqlOperation(mQry));
      } else {
        result = await API.graphql(graphqlOperation(mQry, variables));
      }

      await configureGenericAppSync();
      return result; // Return the result directly

    } catch (error) {
      // If we haven't reached max retries, try again
      if (attempts < maxRetries) {
        const delay = retryDelay * Math.pow(2, attempts - 1); // Exponential backoff
        await new Promise(resolve => setTimeout(resolve, delay));
        return executeWithRetry(); // Recursive retry
      }

      // If we've exhausted all retries, throw the error
      await configureGenericAppSync();
      throw error; // Throw the error to be handled by the caller
    }
  };

  try {
    const result = await executeWithRetry();
    await configureGenericAppSync();
    return result;
  } catch (error) {
    await configureGenericAppSync();
    throw error;
  }
};
